/* Model */
class EventLibraryModel extends App.Models.BaseModel {
    modelUrl = 'resources/eventLibrary.json';

    url = () => this.modelUrl;
}

App.Models.EventLibrary = EventLibraryModel;